import { Client } from "@/service/client";
import { Project } from "@/shared/model/project.model";
import { Suggestion } from "@/shared/model/suggestion.model";

export class ProjectApi {
  private client: Client;

  constructor(client: Client) {
    this.client = client;
  }

  async create(data: { name: string }): Promise<Project> {
    const response = await this.client.fetch(`/project`, {
      method: "POST",
      body: JSON.stringify(data),
    });

    const json = await response.json();

    return json.data;
  }

  async list(): Promise<Project[]> {
    const response = await this.client.fetch(`/project`);

    const json = await response.json();

    return json.data;
  }

  async get(id: string): Promise<Project> {
    const response = await this.client.fetch(`/project/${id}`);

    const json = await response.json();

    return json.data;
  }

  async update(id: string, data: Partial<Project>): Promise<Project> {
    const response = await this.client.fetch(`/project/${id}`, {
      method: "PUT",
      body: JSON.stringify(data),
    });

    const json = await response.json();

    return json.data;
  }

  async generateSuggestion(
    projectId: string,
    url: string,
    data_source: string,
    ai_model: string
  ): Promise<Suggestion> {
    const response = await this.client.fetch(
      `/project/${projectId}/suggestion`,
      {
        method: "POST",
        body: JSON.stringify({ url, data_source, ai_model }),
      }
    );

    const json = await response.json();

    return json.data;
  }

  async listSuggestions(id: string): Promise<Suggestion[]> {
    const response = await this.client.fetch(`/project/${id}/suggestion`);

    const json = await response.json();

    return json.data;
  }

  async getSuggestion(id: string, suggestionId: string): Promise<Suggestion> {
    const response = await this.client.fetch(
      `/project/${id}/suggestion/${suggestionId}`
    );

    const json = await response.json();

    return json.data;
  }

  async delete(id: string): Promise<void> {
    await this.client.fetch(`/project/${id}`, {
      method: "DELETE",
    });
  }
}
